export const truncateWithEllipsis = (text: string, maxLength: number) => {
  if (!text) return '';

  return text.length > maxLength ? `${text.slice(0, maxLength - 3)}...` : text;
};
